





































import { Component, Vue } from "@/shared/vuepack";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { FetchState, HsabExpenseFormType, ManagedExpenseFilterType, } from "@/shared/types";
import HsabExpenseCardRow from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRow.vue";
import ActionNeededExpenseWidgetRow from "@/employee/components/hsabExpenses/ActionNeededExpenseWidgetRow.vue";
import * as RouteNames from "@/employee/route-names";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import DebitCardTransactionModal from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  computed: {
    FetchState () {
      return FetchState;
    }
  },
  components: {
    DebitCardTransactionModal,
    HsabExpenseDetailsModal,
    HsabExpenseEditModal,
    ActionNeededExpenseWidgetRow,
    HsabExpenseCardRow,
    GenericLoadingSpinner }
})
export default class ActionNeededExpensesWidget extends Vue {
  managedExpenseStore = useManagedExpenseStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  RouteNames = RouteNames;
  HsabExpenseFormType = HsabExpenseFormType;

  created () {
    this.managedExpenseStore.loadActionNeededPreview();
  }

  navigateToActionNeeded () {
    this.$router.push({ name: RouteNames.HsabExpenseManagement, params: { filter: ManagedExpenseFilterType.ActionNeeded } });
  }
}
